import React from "react";

/**
 * StatusDropdown Component
 * Reusable status filter dropdown (All/Active/Inactive)
 */
const StatusDropdown = ({
  statusFilter,
  setStatusFilter,
  isDropdownOpen,
  setIsDropdownOpen,
  dropdownRef,
  label = "Filter by Status",
  showForUserTypes = null, // Array of user types that should see this
  currentUserType = null,
}) => {
  // If showForUserTypes is specified, check if current user type should see this
  if (showForUserTypes && !showForUserTypes.includes(currentUserType)) {
    return null;
  }

  return (
    <div
      className="user-status-dropdown"
      ref={dropdownRef}
      // Ensure the status list can be absolutely positioned without affecting layout
      style={{ position: "relative" }}
    >
      <div className="user-status-dropdown-label" htmlFor="statusFilter">
        {label}
      </div>
      <div className="custom-dropdown-user">
        <div
          className={`showing-name ${isDropdownOpen ? "open" : "close"}`}
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        >
          {statusFilter || "Active"}
        </div>
      </div>
      {isDropdownOpen && (
        <ul
          className="status-list"
          // Tracker.css has absolute positioning commented out; keep layout stable here.
          style={{ position: "absolute", top: "52px", left: 0, width: "100%", zIndex: 99 }}
          onMouseDown={(e) => e.stopPropagation()}
          onClick={(e) => e.stopPropagation()}
        >
          <li
            onClick={() => {
              setStatusFilter("All");
              setIsDropdownOpen(false);
            }}
            className={statusFilter === "All" ? "selected-item" : ""}
            onMouseDown={(e) => e.stopPropagation()}
          >
            All
          </li>
          <li
            onClick={() => {
              setStatusFilter("Active");
              setIsDropdownOpen(false);
            }}
            className={statusFilter === "Active" ? "selected-item" : ""}
            onMouseDown={(e) => e.stopPropagation()}
          >
            Active
          </li>
          <li
            onClick={() => {
              setStatusFilter("Inactive");
              setIsDropdownOpen(false);
            }}
            className={statusFilter === "Inactive" ? "selected-item" : ""}
            onMouseDown={(e) => e.stopPropagation()}
          >
            Inactive
          </li>
        </ul>
      )}
    </div>
  );
};

export default StatusDropdown;

